// Main Scripts
// ---------------------
import mainFeature from './js/widgets/mainFeature.js';
import mainCards from './js/widgets/mainCards.js';
import seoWidget from './js/widgets/seoWidget.js';
import cardWidgetStats from './js/widgets/cardWidgetStats.js';
import doubleGalleryStructure from './js/widgets/doubleGalleryStructure.js';
import signupWidget from './js/widgets/signupWidget.js';
import sponsors from './js/widgets/sponsors.js';
import footerNavItems from './js/widgets/footerNavItems.js';

// Secondary Scripts
// ---------------------
import featureLineUp from './js/featureLineUp.js';
import './js/localjs.js';

$(document).ready(function () {
  if (window.location.pathname === '/') {
    mainFeature();
    mainCards();
    seoWidget();
    cardWidgetStats();
    doubleGalleryStructure('gallerySliderOne', gallerySliderOneOpts);
    doubleGalleryStructure('gallerySliderTwo', gallerySliderTwoOpts);
    signupWidget();
    sponsors();
  } else if (window.location.pathname === '/events') {
    $('body').addClass('events-page');
  } else {
    featureLineUp();
  }
  footerNavItems();
});
